export default __webpack_public_path__ + "static/media/taway.3e56a7a8.svg";